import { calculation } from "@/method";
import Echarts from "echarts";
const color = ['#00C6BD', '#42585D', '#FF605F', '#FFD700'];


export default ({
    data = [],
    last = [],
    area = [],
    arealast = [],
    interval = [],
    intervallast = [],
    areaLen = 1,
    intervalLen = 1,
}, week) => {

    return {
        data: compute({ data, week }),
        last: compute({ data: last, week }),
        area: compute({ data: area, week, length: areaLen }),
        arealast: compute({ data: arealast, week, length: areaLen }),
        interval: compute({ data: interval, week, length: intervalLen }),
        intervallast: compute({ data: intervallast, week, length: intervalLen }),
    }
}

function compute({ data, week, length }) {
    let _data = [];
    Object.entries(data).forEach((item, i) => {
        let _item = {
            ...item[1],
            occ: calculation(item[1].sold, item[1].ava, 4),
            adr: calculation(item[1].roomrev, item[1].sold, 4),
        };
        _item.revpar = (_item.occ * _item.adr).toFixed(2);
        if (i > 0) {
            _item.occ_g = calculation(_item.occ - _data[i - 1].occ, _item.occ, 4);
            _item.adr_g = calculation(_item.adr - _data[i - 1].adr, _item.adr, 4);
            _item.revpar_g = calculation(_item.revpar - _data[i - 1].revpar, _item.revpar, 4);
            _item.fb_g = calculation(_item.fb - _data[i - 1].fb, _item.fb, 4);
        }
        if (length && length >= 1) {
            _item.fb = (_item.fb / length).toFixed(2);
        }
        _data[i] = _item;
    });
    return _data
}

export const setKarte = ({
    year, week, dataY, title, type = ""
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById("chart"));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title,
            textStyle: {
                fontSize: 20
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name),
            textStyle: {
                fontSize: 18
            }
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                },
                data: new Array(Number(week < 10 ? week : 10)).fill(1).map((x, i) => `${year}-${~~(week - (week < 10 ? week : 10) + i + 1)}`)
            }
        ],
        yAxis: {
            type: 'value',
            name: '',
            axisLabel: {
                formatter: type == 'perncet' ? '{value}%' : '{value}'
            },

        },
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: "line",
                smooth: true,
                data: type == "percent" ? x.data.map(x => (x * 100).toFixed(1)) : x.data,
            }
        }),
    }

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/groupanalysisChart/compute.js